import script from "./summary.vue?vue&type=script&lang=ts&setup=true"
export * from "./summary.vue?vue&type=script&lang=ts&setup=true"

import "./summary.vue?vue&type=style&index=0&id=6ea98746&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ea98746"]])

export default __exports__